import React, { useEffect, useRef, useState } from "react";
import {
    Row,
    Col,
    Typography,
    Tag,
    Menu,
    Dropdown,
    Icon,
    Button,
    Modal,
    Select,
    DatePicker,
    message,
    Table,
    Divider,
} from "antd";
import moment from "moment";

import { fetchReportListApi, deleteReportListApi } from "utils/apiService";
import Loader from "../../../components/Loader/Loader";
import emptyImage from "../../../media/empty-reports-img.svg";
import ExportReportModal from "./ExportReportModal";
// import "./generated-reports.scss";

const { Text } = Typography;
const { Option } = Select;

export default function GeneratedReport(props) {
    const [tableflag, setTableflag] = useState(true)
    const [filterType, setFilterType] = useState(null);
    const [startDate, setStartDate] = useState(null)
    const [createReport, setCreateReport] = useState(false);
    const transactionflag = useRef("transaction");


    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteuid, setDeleteuid] = useState(null);

    const [reportList, setReportList] = useState(null);

    const toggleDeleteModal = () => {
        setDeleteModal(!deleteModal);
    };

    const loadtable = () => {
        fetchReportListApi({
            requestData: {
                page: 1,
                start_date: startDate,
                status: filterType,
            },
            resCallback: () => { },
            res200Callback: (res) => {
                setReportList(res.data);
                if (res.data?.report_list.length > 0) {
                    setTableflag(false);
                };
            },
        });
    }

    useEffect(() => {
        loadtable();
    }, [startDate, filterType]);

    const columns = [
        {
            title: "Report Title",
            dataIndex: "report_title",
            key: "report_title",
            render: (data) => {
                return (
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "16px",
                            lineHeight: "24px",
                            color: "#181818",
                        }}>
                        {data ? data : "-"}
                    </Text>
                );
            },
        },
        {
            title: "Generated On",
            dataIndex: "date_created",
            key: "date_created",
            render: (data) => {
                return (
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#747474",
                        }}>
                        {data ? data : "29 June 2020"}
                    </Text>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                let { color, tag } = status
                    ? { color: "green", tag: "Completed" }
                    : { color: "yellow", tag: "Processing" };
                return (
                    <Tag color={color} key={tag}>
                        {tag.toUpperCase()}
                    </Tag>
                );
            },
        },
        {
            title: "Actions",
            dataIndex: "report_url",
            key: "report_url",
            render: (url) =>
                true ? (
                    <a href={url} target={"_blank"} rel='noopener noreferrer' style={{ color: "green" }}>
                        Download Report
                    </a>
                ) : null,
        },
        {
            title: "",
            dataIndex: "uuid",
            key: "uuid",
            render: (data) => {
                return !props.viewOnly ? (
                    <Dropdown
                        placement={"bottomLeft"}
                        overlay={
                            <Menu>
                                <Menu.Item
                                    onClick={(e) => {
                                        // e.stopPropagation();
                                        setDeleteuid(data);
                                        toggleDeleteModal();
                                    }}>
                                    <Text style={{ color: "#F5222D" }}>Delete</Text>
                                </Menu.Item>
                            </Menu>
                        }>
                        <Icon
                            type='more'
                            onClick={(e) => {
                                // e.stopPropagation();
                            }}
                            style={{ fontSize: "16px", color: "#747474" }}
                        />
                    </Dropdown>
                ) : (
                    <></>
                );
            },
        },
    ];

    return false ? (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FAFAFA",
            }}>
            <Loader />
        </div>
    ) : (
        <Row
            style={{
                width: "100%",
                padding: "40px 25px 0",
                margin: "60px auto 20px",
                backgroundColor: "#FAFAFA",
            }}
            gutter={[12, 48]}>
            <Row type='flex' justify='space-between' align='middle'>
                <Text
                    style={{
                        color: "#181818",
                        /*fontFamily: "Gotham",*/ fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "24px",
                        lineHeight: "39px",
                        marginBottom: "8px",
                    }}>
                    Generate Reports
                </Text>
            </Row>
            <Row style={{ display: "flex", flexDirection: "row" }}>
                <Col style={{ padding: "16px", background: "#ffffff", marginRight: "16px" }}>
                    <div style={{ fontSize: "16px", marginBottom: "16px", fontWeight: "bold" }}>
                        <Icon type='file' style={{ marginRight: "11px" }} />
                        Generate transaction report
                    </div>
                    <div style={{ color: "#747474", marginBottom: "16px" }}>
                        Generate and download transaction reports. Get custom reports for any date & customer.{" "}
                    </div>
                    <Button
                        style={{
                            color: "#ffffff",
                            height: "auto",
                            backgroundColor: "#fec708",
                            padding: "13px 16px",
                            fontWeight: "bold",
                            borderRadius: "6px",
                        }}
                        onClick={() => {
                            transactionflag.current = "transaction";
                            setCreateReport(true);
                        }}>
                        Generate Report
                    </Button>
                </Col>
                <Col style={{ padding: "16px", background: "#ffffff", marginRight: "16px" }}>
                    <div style={{ fontSize: "16px", marginBottom: "16px", fontWeight: "bold" }}>
                        <Icon type='file' style={{ marginRight: "11px" }} />
                        Generate voucher report
                    </div>
                    <div style={{ color: "#747474", marginBottom: "16px" }}>
                        Generate and download voucher reports. Get custom reports for any date & customer.{" "}
                    </div>
                    <Button
                        style={{
                            color: "#ffffff",
                            height: "auto",
                            backgroundColor: "#fec708",
                            padding: "13px 16px",
                            fontWeight: "bold",
                            borderRadius: "6px",
                        }}
                        onClick={() => {
                            transactionflag.current = "voucher";
                            setCreateReport(true);
                        }}>
                        Generate Report
                    </Button>
                </Col>
                <Col style={{ padding: "16px", background: "#ffffff", marginRight: "16px" }}>
                    <div style={{ fontSize: "16px", marginBottom: "16px", fontWeight: "bold" }}>
                        <Icon type='file' style={{ marginRight: "11px" }} />
                        Generate Customer report
                    </div>
                    <div style={{ color: "#747474", marginBottom: "16px" }}>
                        Generate and download Customer reports. Get custom reports for any date & Cohort.{" "}
                    </div>
                    <Button
                        style={{
                            color: "#ffffff",
                            height: "auto",
                            backgroundColor: "#fec708",
                            padding: "13px 16px",
                            fontWeight: "bold",
                            borderRadius: "6px",
                        }}
                        onClick={() => {
                            transactionflag.current = "customer";
                            setCreateReport(true);
                        }}>
                        Generate Report
                    </Button>
                </Col>
            </Row>
            <ExportReportModal
                modalflag={transactionflag.current}
                createReport={createReport}
                setCreateReport={setCreateReport}
                loadtable={loadtable}
            />
            <Divider />
            <Row type='flex' justify='space-between' align='middle'>
                <Col>
                    <Text
                        style={{
                            color: "#181818",
                            /*fontFamily: "Gotham",*/ fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "24px",
                            lineHeight: "39px",
                        }}>
                        Download Reports
                    </Text>
                </Col>
                <Row type='flex'>
                    <Select
                        value={filterType}
                        onSelect={(value) => {
                            setFilterType(value);
                        }}
                        style={{
                            border: "1px solid #D9D9D9",
                            boxSizing: "border-box",
                            borderRadius: "5px",
                            backgroundColor: "#FFFFFF",
                            width: "150px",
                            marginRight: "8px",
                            display: "flex",
                            alignItems: "center",
                            // justifyContent: "space-between"
                        }}>
                        <Option value=''>All Reports</Option>
                        <Option value='processing'>Pending</Option>
                        <Option value='completed'>Completed</Option>
                    </Select>
                    <DatePicker
                        // disabledDate={disabledStartDate}
                        value={startDate}
                        placeholder='Generated On'
                        onChange={(value) => {
                            setStartDate(value);
                        }}
                        // onOpenChange={handleStartOpenChange}
                        style={{
                            border: "1px solid #D9D9D9",
                            // borderRight: "none",
                            boxSizing: "border-box",
                            borderRadius: "5px",
                            backgroundColor: "#FFFFFF",
                            // marginRight: "-2px",
                            width: "175px",
                        }}
                    />
                </Row>
            </Row>
            {tableflag ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FAFAFA",
                    }}>
                    <img
                        src={emptyImage}
                        alt='Illustration for empty reports list'
                        style={{ height: "246px", width: "240px" }}
                    />
                    <Text
                        style={{
                            fontSize: "20px",
                            color: "#181818",
                            fontWeight: "bold",
                            marginTop: "16px",
                        }}>
                        You have not generated any{" "}
                        <span role='img' aria-label='Report emoji'>
                            &#128195;
                        </span>{" "}
                        Report yet
                    </Text>
                    <Text style={{ color: "#747474", marginTop: "8px" }}>All generated reports will appear here!</Text>
                </div>
            ) : (
                <div>
                    <Table
                        columns={columns}
                        dataSource={reportList?.report_list}
                    // expandedRowRender={(record) => {
                    //     return (
                    //         <div style={{ display: "flex", flexDirection: "row" }}>
                    //             <div style={{ padding: "4px", marginRight: "12px" }}>
                    //                 <div>Selected Dates</div>
                    //                 <div>12/02/2022 - 12/02/2022</div>
                    //             </div>
                    //             <div style={{ padding: "4px", marginRight: "12px" }}>
                    //                 <div>Selected Customer</div>
                    //                 <div>
                    //                     {["Customer1", "Customer1", "Customer1"].map((item) => {
                    //                         return <div>{item}</div>;
                    //                     })}
                    //                 </div>
                    //             </div>
                    //             <div style={{ padding: "4px", marginRight: "12px" }}>
                    //                 <div>Selected Cohorts</div>
                    //                 <div></div>
                    //             </div>
                    //             <div style={{ padding: "4px", marginRight: "12px" }}>
                    //                 <div>Selected Type</div>
                    //                 <div></div>
                    //             </div>
                    //         </div>
                    //     );
                    // }}
                    // expandIconColumnIndex={4}
                    // expandIconAsCell={true}
                    // expandRowByClick
                    // expandIcon={(flag) => {
                    //     return (
                    //         <Icon
                    //             type={flag.expanded ? "up" : "down"}
                    //             style={{ color: "#A3A3A3", fontSize: "18px" }}
                    //         />
                    //     );
                    // }}

                    //   pagination={{
                    //     showQuickJumper: true,
                    //     current: pageNum,
                    //     pageSize: pageDetails.pageSize,
                    //     total: pageDetails.pageSize * pageDetails.totalPages,
                    //   }}
                    //   onChange={(pagination) => {
                    //     handlePageChange(pagination);
                    //   }}
                    //   loading={tableLoading}
                    />
                    <Modal
                        centered
                        visible={deleteModal}
                        destroyOnClose
                        maskClosable={false}
                        onCancel={toggleDeleteModal}
                        footer={null}>
                        <Row className='modal-row'>
                            <Row>
                                <Icon
                                    type='delete'
                                    style={{
                                        color: "#181818",
                                        fontSize: "24px",
                                        marginRight: "16px",
                                    }}
                                />
                                <Text
                                    style={{
                                        fontWeight: "bold",
                                        color: "#181818",
                                        fontSize: "24px",
                                    }}>
                                    Delete item
                                </Text>
                            </Row>
                            <Row style={{ marginTop: "24px" }}>
                                <Col span={24}>
                                    <Text>Are you sure you want to delete this record?</Text>
                                </Col>
                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={18}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            boxShadow: "none",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#FFFFFF",
                                            color: "#181818",
                                        }}
                                        onClick={toggleDeleteModal}>
                                        Cancel
                                    </Button>
                                </Col>
                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={6}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#C91713",
                                            color: "#FFFFFF",
                                        }}
                                        onClick={() => {
                                            deleteReportListApi({
                                                requestData: {
                                                    reports_uuid: deleteuid
                                                },
                                                resCallback: () => { },
                                                res200Callback: (res) => {
                                                    loadtable();
                                                    toggleDeleteModal();
                                                },
                                            });
                                        }}>
                                        Delete
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </Modal>
                </div>
            )}
        </Row>
    );
}
